import * as React from "react"

export const PlaylistInteractionContext = React.createContext<PlaylistInteractionContext | null>(null)

interface PlaylistInteractionContext {
  activePlaylistId: string | null
  setActivePlaylist: (id: string) => void
  clearActivePlaylist: () => void
}
